import React from "react";
import { Row, Col, Modal, Button } from "react-bootstrap";
import TBLCupons from "../../components/TBLCupons";
import DetalhesCupom from "./DetalhesCupons";
import { GetCupons, DeleteCupons } from "../../providers/CuponsProvider";
import FilterBar from "./filter-bar";
import CadastrarEditarModal from "./modais/CadastrarEditarModal";
import { toast } from "react-toastify";
import { ListarEstabelecimentosSemPaginacao } from "../../providers/EstabelecimentoProvider";

export default class CuponsV2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      etabelecimentos: [], // todos estabelecimentos
      cupons: [], // todos os cupons de um estabelecimento
      modal_show: false,
      modal_mode_editar: false,
      modal_mode_editar_data: {},
      modal_mode_view_data: {},
      modal_show_view: false,
      dias: [
        { label: "Segunda", value: "1", horarios_dia: [] },
        { label: "Terça", value: "2", horarios_dia: [] },
        { label: "Quarta", value: "3", horarios_dia: [] },
        { label: "Quinta", value: "4", horarios_dia: [] },
        { label: "Sexta", value: "5", horarios_dia: [] },
        { label: "Sabádo", value: "6", horarios_dia: [] },
      ],
      cupom_deletar: 0,
      modal_show_delete: false,
    };
  }

  handleModal = () =>
    this.setState({
      modal_show: !this.state.modal_show,
      modal_mode_editar: false,
      modal_mode_editar_data: {},
    });

  handleModalView = () => {
    this.setState({
      modal_show_view: !this.state.modal_show_view,
    });
  };
  limparFiltroCupons = async () => {
    const cupons = await GetCupons();
    this.setState({ cupons });
  };
  handleModalDelete = () => {
    this.setState({
      modal_show_delete: !this.state.modal_show_delete,
    });
  };

  buscarEstabelecimentos = async () => {
    return new Promise(async (resolve, reject) => {
      try {
        const docs = await ListarEstabelecimentosSemPaginacao();
        let estabelecimentos = [];
        for (let estabelecimento of docs)
          estabelecimentos.push({
            label: estabelecimento.nome_fantasia,
            value: estabelecimento._id,
            estabelecimento,
          });
        resolve(estabelecimentos);
      } catch (error) {
        reject(error);
      }
    });
  };
  handleCupons = (cupons) =>
    this.setState({
      cupons,
    });
  receberDadosTabela = (tipo, dados) => {
    if (tipo === "editar") {
      this.setState({
        modal_mode_editar: true,
        modal_mode_editar_data: dados,
        modal_show: true,
      });
    }
    if (tipo === "ver_detalhes") {
      this.setState({
        modal_mode_view_data: {
          ...dados,
          dias: this.state.dias,
        },
        modal_show_view: true,
      });
    } else if (tipo === "deletar") {
      this.setState({ cupom_deletar: dados, modal_show_delete: true });
    } else {
      return;
    }
  };
  handleShowAlert = (mensagem, variant) => {
    if (variant === "success") {
      toast.success(mensagem);
    } else {
      toast.error(mensagem);
    }
  };

  deletarCupom = async () => {
    try {
      await DeleteCupons(this.state.cupom_deletar._id);
      await this.atualizarListaCupons();
      this.handleModalDelete();
      this.handleShowAlert("Cupom deletado com sucesso", "success");
    } catch (error) {
      this.handleShowAlert(error.error, "error");
    }
  };

  limparForm = () => {
    for (let state in this.state)
      this.setState({
        [state]: "",
      });
  };
  atualizarListaCupons = async () => {
    const estabelecimentos = await this.buscarEstabelecimentos();
    const cupons = await GetCupons();
    this.setState({ estabelecimentos, cupons });
  };
  componentDidMount = async () => {
    const estabelecimentos = await this.buscarEstabelecimentos();
    const cupons = await GetCupons();
    this.setState({ estabelecimentos, cupons });
  };
  render() {
    return (
      <React.Fragment>
        <br />
        <Row>
          <Col md={9}>
            <h3>Painel de Cupons</h3>
          </Col>
        </Row>
        <br></br>
        {this.state.estabelecimentos?.length > 0 ? (
          <FilterBar
            handleCupons={this.handleCupons}
            estabelecimentos={this.state.estabelecimentos}
            cupons={this.state.cupons}
            handleModal={this.handleModal}
            limparFiltroCupons={this.limparFiltroCupons}
          />
        ) : null}

        <div>
          <br></br>
          <TBLCupons
            data={this.state.cupons}
            numRows={13}
            dataCallback={this.receberDadosTabela}
          ></TBLCupons>
        </div>
        <CadastrarEditarModal
          show={this.state.modal_show}
          handleModal={this.handleModal}
          title={"Cadastrar Cupom"}
          modoEditarEstab={this.state.modal_mode_editar}
          data={this.state.modal_mode_editar_data}
          estabelecimentos={this.state.estabelecimentos}
          handleShowAlert={this.handleShowAlert}
          atualizarListaCupons={this.atualizarListaCupons}
        />
        <Modal size="xl" show={this.state.modal_show_view} onHide={this.handleModalView}>
          <Modal.Header closeButton className="modalHeader">
            <Modal.Title>
              {this.state.row
                ? `Código pedido: ${this.state.data.codigo} - ${this.state.data.atividade
                    .replace("_", " ")
                    .toUpperCase()}`
                : null}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <DetalhesCupom cupom={this.state.modal_mode_view_data}></DetalhesCupom>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleModalView}>
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          size="sm"
          show={this.state.modal_show_delete}
          onHide={this.handleModalDelete}
        >
          <Modal.Header closeButton>
            <Modal.Title>Alerta</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Deseja realmente excluir o cupom?</p>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                this.handleModalDelete();
              }}
            >
              Não
            </Button>
            <Button variant="primary" onClick={this.deletarCupom}>
              Sim
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    );
  }
}
